import { lazy, Suspense } from 'react';
import { createFileRoute, type SearchSchemaInput } from '@tanstack/react-router';
import { RoutePending } from '@/components/app/route-pending';
import type { InboxSearch } from '@/features/operator-inbox/inbox-address';

// The page in a chunk of its own, loaded from this route's: the pieces it shares with other pages are then listed by
// that chunk, not by the entry the sign-in page loads (its 150 KB budget).
const InboxRoute = lazy(() => import('@/features/operator-inbox/inbox-route').then((m) => ({ default: m.InboxRoute })));

export const Route = createFileRoute('/_authed/inbox')({
  // The address is passed on unread and the page reads it (`parseInboxSearch`, in its own chunk): a route's validator
  // ships in the entry chunk, which the sign-in page loads (its 150 KB budget).
  validateSearch: (search: InboxSearch & SearchSchemaInput): InboxSearch => search,
  // No loader: the shell already asks whether this seat runs the campaigns (`useOperator`), and PersonaPage shows
  // `pending` until it knows, so nothing flashes; a loader would only add its chunk list to the sign-in page's entry.
  component: Inbox,
});

function Inbox() {
  return (
    <Suspense fallback={<RoutePending />}>
      <InboxRoute />
    </Suspense>
  );
}
